module.exports = function duration(mins) {
  const value = Number(mins);
  if (mins == null || !Number.isFinite(value) || value < 0) return '—';
  const units = [[Math.floor(value / 1440), 'day'], [Math.floor((value % 1440) / 60), 'hr'], [value % 60, 'min']];
  return units.filter(([count]) => count).map(([count, unit]) => count + ' ' + unit + (count === 1 ? '' : 's')).join(' ') || '0 mins';
};
